module.exports = __webpack_public_path__ + "cancellara-dist/img/sodexo.b700dd17.png";